<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card styleClass="very-compact-card p-3">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="taskType.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Бюджетная статья</label>
            <crm-direction-single-select
              [directions]="directions"
              [(selectedDirection)]="taskType.direction"
              [groupsDisabled]="true"
              [styleClass]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.direction ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-direction-single-select>
            <small
              *ngIf="errors?.direction"
              class="p-error">
              {{ errors.direction | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Дедлайн по-умолчанию</label>
            <p-inputNumber
              [(ngModel)]="taskType.defaultDeadline"
              [min]="0"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.defaultDeadline }"
              styleClass="w-full"
              prefix="Через "
              suffix=" дн."
              class="w-full"></p-inputNumber>
            <small
              *ngIf="errors?.defaultDeadline"
              class="p-error">
              {{ errors.defaultDeadline | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Приоритет по-умолчанию</label>
            <crm-single-select
              dataKey="name"
              [options]="priorities"
              [(selectedItem)]="taskType.defaultPriority"
              [styleClass]="errors?.defaultPriority ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.defaultPriority ? 'ng-invalid ng-dirty' : ''"
              [isTemplateCombined]="true"
              [filter]="false"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-priority="item">
                {{ priority?.value | helpdeskTaskPriorityName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.defaultPriority"
              class="p-error">
              {{ errors.defaultPriority | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Шаблон полей</label>
            <crm-eav-entity-type-single-select
              [(selectedType)]="taskType.entityType"
              [isError]="$any(errors?.entityType)"
              appendTo="body"></crm-eav-entity-type-single-select>
            <small
              *ngIf="errors?.entityType"
              class="p-error">
              {{ errors.entityType | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card
        header="Участники"
        styleClass="mt-3">
        <div class="field">
          <label class="font-medium">Ответственный</label>
          <crm-user-single-select
            [(selectedUser)]="taskType.responsible"
            [isError]="$any(errors?.responsible)"
            [showClear]="true"
            appendTo="body"></crm-user-single-select>
          <small
            *ngIf="errors?.responsible"
            class="p-error">
            {{ errors.responsible | join }}
          </small>
        </div>

        <div class="field">
          <label class="font-medium">Группы</label>
          <crm-multi-select
            [options]="userGroupAuditors"
            [(selectedItems)]="taskType.userGroupAuditors"
            appendTo="body"
            [class]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''"
            [styleClass]="errors?.userGroupAuditors ? 'ng-invalid ng-dirty' : ''">
          </crm-multi-select>
          <p
            *ngIf="errors?.userGroupAuditors"
            class="p-error">
            {{ errors.userGroupAuditors | join }}
          </p>
        </div>
      </p-card>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <button
        pButton
        [label]="saveButtonLabel"
        class="p-button-success"
        (click)="saveTaskType()"></button>
      <div class="flex align-items-center gap-2">
        <button
          *ngIf="(form$ | async)?.isShowDelete && !taskType.deleted"
          pButton
          label="Удалить"
          class="p-button-danger p-button-text"
          (click)="deleteTaskType()"></button>
        <button
          *ngIf="(form$ | async)?.isShowDelete && taskType.deleted"
          pButton
          icon="pi pi-undo"
          label="Восстановить"
          class="p-button-info p-button-text"
          (click)="restoreTaskType()"></button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
